import { karhooBookTaxi, karhooGetDetail, karhooGetPassengerDetail, karhooCancel, saveAttemptsKarhoo } from '@/api/service'
const karhooBook = (context, payload) => {
  return karhooBookTaxi(payload).then((response) => {
    return response
  })
}

const getDetail = (context, payload) => {
  return karhooGetDetail(payload).then((response) => {
    return response
  })
}
const getPassengerDetail = (context, payload) => {
  return karhooGetPassengerDetail(payload).then((response) => {
    return response
  })
}

const cancelTaxi = (context, payload) => {
  return karhooCancel(payload).then((response) => {
    return response
  })
}

const saveAttempts = (context, payload) => {
  return saveAttemptsKarhoo(payload).then((response) => {
    return response
  })
}
export default {
  karhooBook,
  getDetail,
  cancelTaxi,
  getPassengerDetail,
  saveAttempts
}
